import { render } from "./ManageBooks.vue?vue&type=template&id=7e1f6071&scoped=true"
import script from "./ManageBooks.vue?vue&type=script&lang=js"
export * from "./ManageBooks.vue?vue&type=script&lang=js"

import "./ManageBooks.vue?vue&type=style&index=0&id=7e1f6071&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1f6071"]])

export default __exports__